export default "__VITE_ASSET__BxkPgKHS__"